module.exports = __webpack_public_path__ + "static/img/4485_phase_function_Paper_PointsHejduk_Prediction.aaf41eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4485_phase_function_Paper_PointsHejduk_Prediction.png
// module id = oCgf
// module chunks = 0